import Vue from 'vue';
import moment from 'moment';

Vue.filter('capitalize', function(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('upperCase', function(value) {
  if (!value) return '';
  value = value.toString();
  return value.toUpperCase();
});

Vue.filter('trim', function(value) {
  if (!value) return '';
  return value.trim();
});

Vue.filter('substring', function(value, start, cant) {
  if (!value) return '';
  value = value.toString();
  return value.substring(start, cant);
});

Vue.filter('fechaHora', function(value) {
  if (!value) return '';
  return moment(value, 'YYYY-MM-DD HH:mm').format('DD-MM-YYYY HH:mm');
});

Vue.filter('fechaHoraDDMM', function(value) {
  if (!value) return '';
  return moment(value, 'YYYY-MM-DD HH:mm').format('DD-MM HH:mm');
});
